import React,{Component} from 'react';
import {connect} from 'react-redux'

import {Select} from './FormElements';
import Icon from './Icons';
import { l } from '../functions';
import ListSortedItemsCheckboxes from './ListSortedItemsCheckboxes';
import Switch from '@material-ui/core/Switch';

const mapStateToProps = state => {
    return {
        fetchedLangs : state.rootReducer.fetchedLangs || [],
        fetchedPages : state.rootReducer.fetchedPages || [],
        currentLang : state.rootReducer.currentLang || 1,
    }
}

class ModalDialog extends Component {
	constructor(props) {
        super(props);

        this.state = this.props.datas;
        this.popupTypeMessage = {
            standard : l('A standard popup is triggered when the user clicks on an element on the page that you have linked with the popup'),
            entry : l('An entry pop-up is a pop-up that’s shown to a visitor as soon as your website page loads. It generally blocks the viewer from seeing the page they’ve clicked through to until they engage with you.'),
            exit : l('An exit pop-up is a pop-up that’s shown to a visitor when their cursor leaves the browser window.')
        }
    }

    componentWillReceiveProps({datas}){
        if( this.props.datas !== datas )
            this.setState(datas);
    }

    render() {
        return (
            this.props.open && 
            <div className="modals-dialog">
                <div className="head">
                    <Icon icon="time" onClick={() => this.props.onClose()} /> <h3>{l('Popup settings')}</h3>
                    <button className="new-item" onClick={() => this.props.onSubmit(this.state)}><Icon icon="check" /></button>
                </div>
                <div className="form">
                    <div className="section">
                        <div className="gk-form-row-container">
                            <label className="small">{l('Popup type')}</label>
                            <Select
                                placeholder={l('Popup type')}
                                value={this.state.popupType || null}
                                onChange={(value) => { this.setState({popupType:value}) }}
                                options={
                                    [
                                        {
                                            label : l('Standard'),
                                            value : 'standard'
                                        },
                                        {
                                            label : l('Entry'),
                                            value : 'entry'
                                        },
                                        {
                                            label : l('Exit'),
                                            value : 'exit'
                                        }
                                    ]
                                }
                                dark
                            />
                        </div>
                        {
                            this.state.popupType && 
                            <div className="gk-custom-message"><p>{this.popupTypeMessage[this.state.popupType]}</p></div>
                        }
                    </div>
                    <hr />
                    {
                        (this.state.popupType && this.state.popupType !== 'standard') && 
                        <div className="section">
                            <label className="small">{l('Show popup in')}</label>
                            <ListSortedItemsCheckboxes
                                list={this.state.popupDisplay || []}
                                onCheck={(list) => {this.setState({popupDisplay : list})}}
                                items={this.props.fetchedPages}
                                conditions={[{key:'tab',value:'pages',relation:'==='}]}
                                unSelectParent
                                multiple
                            />
                        </div>
                    }
                    {
                        (this.state.popupType && this.state.popupType !== 'standard') && 
                        <hr />
                    }
                    {
                        (this.state.popupType && this.state.popupType !== 'standard') && 
                        <div className="section">
                            <div className="gk-form-row-container">
                                <label className="small">{l('One time popup')}</label>

                                <Switch
                                    checked={this.state.oneTime || false}
                                    onChange={(e) => { this.setState({oneTime:e.target.checked}) }}
                                />
                            </div>
                        </div>
                    }
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps)(ModalDialog)